import { AxiosError } from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getBoardsByUserId } from "../../../app/api/admin/board";
import { generatePdf, getBrandsData } from "../../../app/api/designerPage";
import { getStylingDetails } from "../../../app/api/trendsFilter";
import { getSnapshotDetails } from "../../../app/api/trendSnapshot";
import { getUserId } from "../../../app/api/user/user";
import { RootState } from "../../../app/store";
import CrossSnapshotIcon from "../../../assets/icons/CrossSnapshotIcon";
import DeleteSnapshotIcon from "../../../assets/icons/DeleteSnapshotIcon";
import DownloadSnapshotIcon from "../../../assets/icons/DownloadSnapshotIcon";
import ShareSnapshotIcon from "../../../assets/icons/ShareSnapshotIcon";
import {
  defaultMaterials,
  postsPerTrend,
  TrendsPerPage,
} from "../../../constants/constants";
import { Board } from "../../../interface/BoardsInterface";
import {
  brandsParams,
  FeedItem,
  GetBrandsParams,
} from "../../../interface/DesignerInterface";
import {
  PreferenceFilters,
  snapshotDataInterface,
} from "../../../interface/SnapshotInterface";
import {
  capitalizeFirstLetter,
  formatNumber,
} from "../../../utils/commonUtils";
import TrendsSidebar from "../../DesignerPage/TrendsSidebar/TrendsSidebar";
import Pagination from "../../Target/Pagination";
import Preferences from "../Preferences";
import Trends from "../Trends/Trends";
import { TrendsRowSkeleton } from "../InstaPostSkeleton";
import DeleteSnapshotModal from "./DeleteSnapshotModal";
import SnapshotShareModal from "./SnapshotShareModal";
import { getSnapshotGraphsJSONDataS3KeyForPdfDownload } from "../../../utils/trendSnapshot-utils/graphsUtilsForSnapshot";
import { checkSnapshotStatus } from "../../../utils/snapshotHelpers";
import {
  archivedTrendLabel,
  filterArchivedGraphRows,
} from "../../../utils/archivedTrends";
interface Props {
  isSidebarOpen: boolean;
  trendsOpen: boolean;
  setTrendsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
interface bargraphDataInterface {
  bet: string;
  impact: string;
  contribution: string;
}
const posts: FeedItem[] = [];
const TrendSnapshotDetails: React.FC<Props> = ({
  isSidebarOpen,
  trendsOpen,
  setTrendsOpen,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const closeBrandsModal = () => setBrandsModalOpen(false);

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [analysisResultSuccess, setAnalysisResultSuccess] =
    useState<boolean>(true);
  const [deleteWarningModal, setDeleteWarningModal] = useState<boolean>(false);
  const [shareSnapshotModal, setShareSnapshotModal] = useState<boolean>(false);
  const [snapshotDetails, setSnapshotDetails] = useState<snapshotDataInterface>(
    {} as snapshotDataInterface
  );
  const [totalVisiblePostsCount, setTotalVisiblePostsCount] =
    useState<number>(0);
  const [trendVisiblePostsCount, setTrendVisiblePostsCount] = useState<
    Record<number, number>
  >({});
  const [totalPopulationCount, setTotalPopulationCount] = useState<number>(0);
  const [bargraphData, setBargraphData] = useState<bargraphDataInterface[]>([]);
  const [snapshotName, setSnapshotName] = useState<string>("");
  const [ownerName, setOwnerName] = useState<string>("");
  const [brandsList, setBrandsList] = useState<{
    [key: string]: brandsParams[];
  }>({});
  const [preferences, setPreferences] = useState<PreferenceFilters>({
    startDate: "",
    endDate: "",
    region: "",
    genre: "",
    product: "",
    gender: "",
    brands: [],
    source: "",
    category: "",
    color: "",
    ageGroup: "",
  });
  const [trendAnalysisFilters, setTrendAnalysisFilters] = useState({
    product_type: "",
    material: "",
    styling_details: "",
  });
  const [trendsTotalPages, setTrendsTotalPages] = useState(1);
  const [stylingDetails, setStylingDetails] = useState<string[]>([]);
  const user = useSelector((state: RootState) => state.user.userInfo);
  const userEmail = user?.email;
  const userName = user?.name;
  const [userId, setUserId] = useState<string>("");
  const [trendsPage, setTrendsPage] = useState<number>(1);
  const [ownerId, setOwnerId] = useState<string>("");
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [trendFilterType, setTrendFilterType] =
    useState<string>("Most Popular");
  const [totalBrandsCount, setTotalBrandsCount] = useState<string>("0");

  //Board

  const [boardsList, setBoardsList] = useState<Board[]>([]);
  const [publicBoards, setPublicBoards] = useState<Board[]>([]);
  const [privateBoards, setPrivateBoards] = useState<Board[]>([]);

  // Snapshot deleted
  const [isDeleted, setIsDeleted] = useState<boolean>(false);

  // Async snapshot status
  const [snapshotStatus, setSnapshotStatus] = useState<string>("");
  const [snapshotFailed, setSnapshotFailed] = useState<boolean>(false);
  const location = useLocation();
  const pendingSnapshotName = (location.state as { snapshotName?: string })
    ?.snapshotName;

  const onScrollItems = () => {};
  const navigate = useNavigate();
  const handleDeleteSnapshot = () => {
    setDeleteWarningModal(true);
  };
  const handleGoBack = () => {
    navigate("/trend-snapshot");
  };
  const handleShareSnapshot = () => {
    setShareSnapshotModal(true);
  };

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleTrendsToggle = () => {
    setTrendsOpen(!trendsOpen);
  };
  const { id } = useParams();
  const numericSnapshotId = Number(id);
  const SNAPSHOT_PDF_DOWNLOADED_KEY = `isSnapshotPdfDownloaded_${numericSnapshotId}`;
  const [isSnapshotPdfDownloaded, setIsSnapshotPdfDownloaded] =
    useState<boolean>(
      () => sessionStorage.getItem(SNAPSHOT_PDF_DOWNLOADED_KEY) === "true"
    );
  const [pdfGenerating, setPdfGenerating] = useState<boolean>(false);
  const [isBrandsModalOpen, setBrandsModalOpen] = useState(false);
  const fetchDetails = async (page: number) => {
    const detailsParams = {
      page: page,
      numberOfTrends: TrendsPerPage,
      postsPerTrend: postsPerTrend,
    };
    try {
      setLoading(true);
      const snapDetails = await getSnapshotDetails(
        numericSnapshotId,
        user,
        detailsParams
      );

      const { status, isNotCompleted } = checkSnapshotStatus(snapDetails);

      if (isNotCompleted) {
        setSnapshotStatus(status);
        if (status === "failed") {
          setSnapshotFailed(true);
        }
        return;
      }

      setSnapshotStatus("completed");
      const archivedTrendNames =
        snapDetails.data.snapshot.genericFilters?.archivedTrendNames || [];
      const visibleTrends = (snapDetails.data.trends || []).filter(
        (trend: { trendOrder: number }) =>
          !archivedTrendNames.includes(archivedTrendLabel(trend.trendOrder))
      );
      setSnapshotDetails({
        ...snapDetails.data,
        trends: visibleTrends,
      });
      setBargraphData(
        filterArchivedGraphRows(
          snapDetails.data.barGraphData,
          archivedTrendNames
        )
      );
      setSnapshotName(snapDetails.data.snapshot.name);
      setOwnerName(snapDetails.data.snapshot.ownerName);
      setOwnerId(snapDetails.data.snapshot.ownerId);
      setTrendsTotalPages(
        Math.ceil(snapDetails.data.snapshot.trendsCount / TrendsPerPage)
      );

      setPreferences(
        snapDetails.data.snapshot.genericFilters.preferenceFilters
      );

      setTrendFilterType(
        snapDetails?.data?.snapshot?.genericFilters?.graphsFilters
          ?.query_type || "Most Popular"
      );

      setTrendAnalysisFilters(
        snapDetails.data.snapshot.genericFilters.trendAnalysisFilters
      );

      // All trends carry the same population count. The snapshot generator
      // currently persists it only as trendVisiblePostsCount, so fall back to
      // the first trend's value when totalPopulationCount is absent.
      const trendVisiblePostsCounts =
        snapDetails.data.snapshot.genericFilters.trendVisiblePostsCount || {};
      const firstTrendVisiblePostsCount =
        Number(Object.values(trendVisiblePostsCounts)[0]) || 0;

      setTotalPopulationCount(
        snapDetails.data.snapshot.genericFilters.totalPopulationCount ??
          firstTrendVisiblePostsCount
      );
      setTotalVisiblePostsCount(
        snapDetails.data.snapshot.genericFilters.totalVisiblePostsCount ??
          firstTrendVisiblePostsCount
      );
      setTrendVisiblePostsCount(trendVisiblePostsCounts);
    } catch (error) {
      console.error("Error fetching snapshot details:", error);
      if (snapshotStatus !== "pending" && snapshotStatus !== "processing") {
        setIsDeleted(true);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleTrendsPageChange = (page: number) => {
    setTrendsPage(page);
  };
  useEffect(() => {
    if (Object.keys(preferences).length !== 0) {
      const params: GetBrandsParams = {};
      if (preferences.gender) params.gender = preferences.gender;
      if (preferences.genre) params.genre = preferences.genre;
      if (preferences.source) params.source = preferences.source;
      if (preferences.region) params.region = preferences.region;
      if (preferences.product) params.product = preferences.product;
      if (preferences.category) params.category = preferences.category;
      if (preferences.ageGroup) params.ageGroup = preferences.ageGroup;
      if (preferences.startDate) {
        params.startDate = `${preferences.startDate} 00:00:00`;
      }
      if (preferences.endDate) {
        params.endDate = `${preferences.endDate} 23:59:59`;
      }
      if (preferences.color) params.colors = preferences.color.toUpperCase();
      getBrandsData(params).then(res => {
        const brandsData = res.brands || {};
        setBrandsList(brandsData);

        const totalCount = Object.values(
          brandsData as Record<string, { handle: string; count: number }[]>
        ).reduce((total, arr) => {
          return (
            total +
            arr.reduce((subTotal, item) => {
              if (
                preferences.brands.length > 0 &&
                !preferences.brands.includes(item.handle)
              ) {
                return subTotal;
              }

              return subTotal + Number(item.count);
            }, 0)
          );
        }, 0);

        setTotalBrandsCount(formatNumber(totalCount));
      });
    }
  }, [preferences]);

  //Board
  const getUserByEmail = async () => {
    if (userEmail) {
      const res = await getUserId(userEmail);
      setUserId(res?.data?.data[0]._id);
    }
  };

  const getBoardsByUser = async () => {
    if (userId) {
      const res = await getBoardsByUserId(userId);
      setPublicBoards(res?.data?.data.public.boards);
      setPrivateBoards(res?.data?.data.private.boards);
      setBoardsList(res?.data?.data);
    }
  };

  useEffect(() => {
    getUserByEmail();
    getBoardsByUser();
  }, [userId]);
  useEffect(() => {
    const getStylingDetail = async () => {
      try {
        const params = {
          category: preferences.category,
          gender: preferences.gender,
          productType: trendAnalysisFilters.product_type,
        };
        const response = await getStylingDetails(params, user);
        setStylingDetails(response.data);
      } catch (error) {
        console.error("Error Fetching Styling Details", error);
        if ((error as AxiosError)?.response?.status !== 400) {
          toast.error("Error Fetching Styling Details", {
            hideProgressBar: true,
          });
        }
      }
    };

    if (
      preferences.category &&
      preferences.gender &&
      trendAnalysisFilters.product_type &&
      (preferences.category === "Ethnic RTW" ||
        preferences.category === "Western RTW")
    ) {
      getStylingDetail();
    }
  }, [trendAnalysisFilters.product_type]);

  useEffect(() => {
    fetchDetails(trendsPage);
  }, [trendsPage]);

  const pollingIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null
  );
  useEffect(() => {
    if (snapshotStatus === "pending" || snapshotStatus === "processing") {
      pollingIntervalRef.current = setInterval(() => {
        fetchDetails(trendsPage);
      }, 4000);
    }

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [snapshotStatus, trendsPage]);

  const handleGeneratePdf = async () => {
    if (pdfGenerating) return;

    if (isSnapshotPdfDownloaded) {
      toast.success(
        "PDF has Already been Downloaded please check notifications",
        {
          hideProgressBar: true,
        }
      );
      return;
    }

    setPdfGenerating(true);
    const toastId = toast.loading("Preparing your PDF...", {
      closeOnClick: false,
      draggable: false,
    });

    try {
      const graphDataJsonUrl =
        await getSnapshotGraphsJSONDataS3KeyForPdfDownload(
          numericSnapshotId,
          user,
          userId
        );
      const payload = {
        from: "snapshot",
        userId,
        userName,
        snapshotId: id,
        filters: {
          preferences: {
            gender: preferences.gender ? preferences.gender : "None",
            source: preferences.source ? preferences.source : "None",
            "Start Date": preferences.startDate
              ? preferences.startDate
              : "None",
            "End Date": preferences.endDate ? preferences.endDate : "None",
            region: preferences.region ? preferences.region : "None",
            genre: preferences.genre ? preferences.genre : "None",
            product: preferences.product ? preferences.product : "None",
            brands: preferences.brands ? preferences.brands : "None",
            category: preferences.category ? preferences.category : "None",
            color: preferences.color ? preferences.color : "None",
            "Age Group": preferences.ageGroup ? preferences.ageGroup : "None",
          },
          "trends-filters": {
            "Product Types": trendAnalysisFilters.product_type
              ? trendAnalysisFilters.product_type
              : "All",
            material: trendAnalysisFilters.material.length
              ? trendAnalysisFilters.material
              : "None",
            "Styling Details": trendAnalysisFilters.styling_details.length
              ? trendAnalysisFilters.styling_details
              : "None",
          },
        },
        graphDataJsonUrl,
      };
      await generatePdf(payload, user);
      sessionStorage.setItem(SNAPSHOT_PDF_DOWNLOADED_KEY, "true");
      setIsSnapshotPdfDownloaded(true);
      toast.update(toastId, {
        render: "PDF is generating. You will be notified once it is done.",
        type: "success",
        isLoading: false,
        autoClose: 4000,
        hideProgressBar: true,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Error generating PDF",
        type: "error",
        isLoading: false,
        autoClose: 4000,
        hideProgressBar: true,
      });
    } finally {
      setPdfGenerating(false);
    }
  };
  if (snapshotFailed) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-80px)] font-poppins font-semibold text-red-500">
        Snapshot generation failed. Please try again.
      </div>
    );
  }

  if (isDeleted) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-80px)] font-poppins font-semibold ">
        This Snapshot has been deleted by the owner.
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col h-[calc(100vh-80px)] ${!isSidebarOpen ? "w-[calc(100vw-265px)]" : "w-[calc(100vw-105px)]"} transition-all duration-500 ease-in-out fixed ml-1 bg-dashboard`}
    >
      <div className="flex justify-between items-center px-3 py-4 font-poppins">
        <div className="flex justify-center items-center gap-1">
          <div className="text-primary font-bold text-[24px]">
            {capitalizeFirstLetter(
              snapshotName || pendingSnapshotName || "Snapshot"
            )}
          </div>
          {(snapshotStatus === "pending" ||
            snapshotStatus === "processing") && (
            <span className="ml-2 text-sm text-gray-500 animate-pulse">
              Generating...
            </span>
          )}
          {snapshotName && (
            <div className="text-tertiary text-[16px]">
              |{" "}
              {moment(snapshotDetails?.snapshot?.createdAt).format(
                "DD/MM/YYYY hh:mm a"
              )}
            </div>
          )}
          {snapshotName && (
            <div className="text-tertiary text-[16px]">| {ownerName}</div>
          )}
        </div>
        <div className="flex gap-4">
          <button
            type="button"
            className={`flex items-center justify-center ${
              pdfGenerating || isSnapshotPdfDownloaded
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
            onClick={handleGeneratePdf}
            disabled={pdfGenerating || isSnapshotPdfDownloaded}
            title={
              isSnapshotPdfDownloaded
                ? "Already downloaded"
                : pdfGenerating
                  ? "Generating PDF..."
                  : "Download PDF"
            }
          >
            <DownloadSnapshotIcon height={24} width={24} fill={"#212121"} />
          </button>
          <div className="cursor-pointer" onClick={handleShareSnapshot}>
            <ShareSnapshotIcon height={24} width={24} fill={"#212121"} />
          </div>
          {ownerId === userId && (
            <div className="cursor-pointer" onClick={handleDeleteSnapshot}>
              <DeleteSnapshotIcon height={24} width={24} />
            </div>
          )}
          <div className="cursor-pointer" onClick={handleGoBack}>
            <CrossSnapshotIcon height={24} width={24} />
          </div>
        </div>
      </div>
      <div className="flex flex-1 overflow-hidden">
        <Preferences
          startDate={preferences?.startDate}
          endDate={preferences?.endDate}
          isCollapsed={sidebarOpen}
          onToggle={handleSidebarToggle}
          setGenre={() => {}}
          genre={preferences?.genre}
          setProduct={() => {}}
          product={preferences?.product}
          setGender={() => {}}
          gender={preferences?.gender}
          ageGroup={preferences?.ageGroup}
          setAgeGroup={() => {}}
          setBrands={() => {}}
          brands={preferences?.brands}
          setStartDate={() => {}}
          setEndDate={() => {}}
          setRegion={() => {}}
          region={preferences?.region}
          genres={[]}
          regions={[]}
          sources={[]}
          source={preferences?.source}
          setSource={() => {}}
          brandsList={brandsList}
          productList={[]}
          color={preferences?.color}
          setColor={() => {}}
          categories={[]}
          category={preferences?.category}
          setCategory={() => {}}
          isBrandsModalOpen={isBrandsModalOpen}
          setBrandsModalOpen={setBrandsModalOpen}
          closeBrandsModal={closeBrandsModal}
          filterId={""}
          filterName={""}
          setFilterId={() => {}}
          setFilterName={() => {}}
          totalBrandsCount={totalBrandsCount}
          TrendSnapshotDisabled={true}
          TrendsSnapshotPreferencesView={true}
        />
        <div className="px-2 flex-1 bg-dashboard">
          <div className="flex justify-between">
            <div className=" h-10 bg-dashboard mb-2 rounded-lg flex  items-center">
              <button
                className="px-3 font-bold text-xs disabled:text-gray-400"
                disabled={true}
              >
                Check Archive
              </button>
              <button
                className="px-3 font-bold text-xs disabled:text-gray-400"
                onClick={() => {}}
                disabled={true}
              >
                Take Snapshot
              </button>
            </div>
            {snapshotStatus !== "pending" &&
              snapshotStatus !== "processing" && (
                <div className="flex justify-center items-center">
                  <div className="text-sm mr-5">
                    Total Posts : <b>{totalPopulationCount}</b>
                  </div>
                </div>
              )}
          </div>
          <div
            className="h-[calc(100vh-200px)] overflow-auto bg-dashboard p-2.5 rounded-lg"
            ref={scrollRef}
            onScroll={onScrollItems}
          >
            <>
              {snapshotStatus === "pending" ||
              snapshotStatus === "processing" ? (
                <div className="flex flex-col items-center justify-center h-full font-poppins text-gray-500">
                  <div className="text-lg font-semibold mb-2">
                    Snapshot creation is in progress.
                  </div>
                  <div className="text-sm">Please visit after some time.</div>
                </div>
              ) : !loading ? (
                snapshotDetails?.trends?.length > 0 ? (
                  <>
                    <div
                      className={` overflow-y-scroll scroller ${trendsTotalPages > 1 ? "h-[calc(100%-50px)]" : "h-full"}`}
                    >
                      {snapshotDetails?.trends?.map((item, index) => {
                        return (
                          <Trends
                            key={index}
                            isSidebarOpen={isSidebarOpen}
                            sidebarOpen={sidebarOpen}
                            name={`Trend ${item.trendOrder}`}
                            selection={item.trendFilters}
                            trendsOpen={trendsOpen}
                            posts={item.posts}
                            privateBoards={privateBoards}
                            setPrivateBoards={setPrivateBoards}
                            publicBoards={publicBoards}
                            setPublicBoards={setPublicBoards}
                            userId={userId}
                            req_id={""}
                            trendSnapshotTrendsView={true}
                            snapshotId={Number(id)}
                            trendNo={item.trendOrder}
                            analysisResultSuccess={true}
                            bet={
                              bargraphData?.[(trendsPage - 1) * 10 + index]
                                ?.bet || "Safe"
                            }
                            impact={
                              bargraphData?.[(trendsPage - 1) * 10 + index]
                                ?.impact || "Strong"
                            }
                            contribution={
                              bargraphData?.[(trendsPage - 1) * 10 + index]
                                ?.contribution || "0.00%"
                            }
                            postCount={item?.postCount}
                            totalVisiblePostsCount={
                              trendVisiblePostsCount?.[item.trendOrder] ??
                              totalVisiblePostsCount
                            }
                          />
                        );
                      })}
                    </div>
                    <div
                      className={`mt-2 ${trendsTotalPages > 0 ? "block" : "hidden"}`}
                    >
                      <Pagination
                        currentPage={trendsPage}
                        totalPages={trendsTotalPages}
                        onPageChange={handleTrendsPageChange}
                      />
                    </div>
                  </>
                ) : (
                  <div className="font-poppins text-center mt-10 w-full">
                    No Trends Found
                  </div>
                )
              ) : (
                <div className="space-y-4">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <TrendsRowSkeleton key={index} trendsOpen={trendsOpen} />
                  ))}
                </div>
              )}
            </>
          </div>
        </div>
        <TrendsSidebar
          isTrendOpen={trendsOpen}
          onTrendToggle={handleTrendsToggle}
          productType={[]}
          selectedProductType={trendAnalysisFilters.product_type}
          setSelectedProductType={() => {}}
          materials={defaultMaterials}
          selectedMaterial={trendAnalysisFilters.material.split(",")}
          setSelectedMaterial={() => {}}
          stylingDetails={stylingDetails}
          selectedStylingDetail={trendAnalysisFilters.styling_details.split(
            ","
          )}
          setSelectedStylingDetail={() => {}}
          runAnalysis={() => {}}
          setAnalysisResultSuccess={setAnalysisResultSuccess}
          refChange={() => {}}
          startDate={""}
          endDate={""}
          region={""}
          genre={""}
          product={""}
          gender={""}
          brands={[]}
          source={""}
          category={""}
          color={""}
          req_id={""}
          analysisResultSuccess={true}
          TrendsSidebarSnapshotExpandedView={true}
          trendFilterType={trendFilterType}
        />
      </div>
      {deleteWarningModal && (
        <DeleteSnapshotModal
          snapshotId={Number(id)}
          ownerId={ownerId}
          closeDeleteModal={() => {
            setDeleteWarningModal(false);
          }}
        />
      )}
      {shareSnapshotModal && (
        <SnapshotShareModal
          onCloseSnapshotShareModal={() => {
            setShareSnapshotModal(false);
          }}
          snapshotName={snapshotName}
          snapshotId={numericSnapshotId}
          ownerName={ownerName}
          ownerId={ownerId}
          postId={id}
        />
      )}
    </div>
  );
};

export default TrendSnapshotDetails;
